import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import {
  logoBlack,
  aiSoftwareIcon,
  marketingAdvertisingIcon,
  technicalSupportIcon,
  teamStaffingIcon,
  aiIndustryIcon,
  webDevIndustryIcon,
  startupIndustryIcon,
  educationIndustryIcon,
  marketingIndustryIcon,
  healthcareIndustryIcon,
  realEstateIndustryIcon,
  ecommerceIndustryIcon
} from '../constants/images';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);
  const [dropdownStates, setDropdownStates] = useState({});

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  // Close dropdowns when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setDropdownStates({});
  }, [location]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = (menuId) => {
    if (window.innerWidth <= 991) {
      setDropdownStates(prev => ({
        ...prev,
        [menuId]: !prev[menuId]
      }));
    }
  };

  // Handle dropdown hover for desktop
  const handleDropdownMouseEnter = (menuId) => {
    if (window.innerWidth > 991) {
      setDropdownStates(prev => ({
        ...prev,
        [menuId]: true
      }));
    }
  };

  const handleDropdownMouseLeave = (menuId) => {
    if (window.innerWidth > 991) {
      setDropdownStates(prev => ({
        ...prev,
        [menuId]: false
      }));
    }
  };

  // Close dropdown when a link is clicked
  const handleDropdownLinkClick = () => {
    setDropdownStates({});
  };
  

  return (
      <header className="site_header site_header_1">
  <div className="header_top text-center">
    <div className="container">
      <p className="m-0">Top 1% Remote Talent &amp; Virtual Teams — Save up to 70% On Hiring Costs While We Scale Your Success Remotely. <Link to="/contact"><u>Start Saving Today</u> <i className="fa-solid fa-angle-right" /></Link></p>
    </div>
  </div>
  <div className={`header_bottom stricky ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
    <div className="container">
      <div className="row align-items-center">
        <div className="col-xl-3 col-lg-2 col-5">
          <div className="site_logo">
            <Link className="site_link" to="/">
              <img src={logoBlack} alt="Company Logo" />
            </Link>
            {/*<div class="badge bg-danger-subtle text-danger">We’re Hiring</div>*/}
          </div>
        </div>
        <div className="col-xl-6 col-lg-7 col-2">
          <nav className="main_menu navbar navbar-expand-lg" ref={menuRef}>
            <div className={`main_menu_inner navbar-collapse justify-content-lg-center ${isMobileMenuOpen ? 'show' : ''}`}>
              <ul className="main_menu_list unordered_list justify-content-center">
                <li className={location.pathname === '/' ? 'active' : ''}>
                  <Link to="/">
                    Home
                  </Link>
                </li>
                <li 
                  className="dropdown"
                  onMouseEnter={() => handleDropdownMouseEnter('hireTalent')}
                  onMouseLeave={() => handleDropdownMouseLeave('hireTalent')}
                >
                  <a 
                    className="nav-link" 
                    href="#" 
                    id="hire_talent_submenu" 
                    role="button"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown('hireTalent');
                    }}
                    aria-expanded={dropdownStates.hireTalent}
                  >
                    Hire Talent
                  </a>
                  <div 
                    className={`dropdown-menu mega_menu_wrapper ${dropdownStates.hireTalent ? 'show' : ''}`} 
                    aria-labelledby="hire_talent_submenu">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="megamenu_pages_wrapper mb-5">
                            <div className="row">
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/Aisoftware" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={aiSoftwareIcon} alt="ai-software SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">AI &amp; Software Engineers</small>
                                  </span>
                                  <span className="description mb-0">
                                    Developers, QA &amp; Testing, AI/ML Engineers, DevOps &amp; Cloud, PMs
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/Digitalmarkiting" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={marketingAdvertisingIcon} alt="marketing-advertising SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Digital Marketing </small>
                                  </span>
                                  <span className="description mb-0">
                                    Email Marketing, SEO, E-commerce, Content Writing, Research &amp; Reporting
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/Adminsupport" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={technicalSupportIcon} alt="technical-support SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Customer Support &amp; Admin</small>
                                  </span>
                                  <span className="description mb-0">
                                    Admin support, Customer support, Live chat, Technical support
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/TeamServices" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={teamStaffingIcon} alt="team-staffing SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Team Service</small>
                                  </span>
                                  <span className="description mb-0">
                                    Remote team scaling, Hire dedicated teams, Talent vetting, Onboarding
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                          <ul className="btns_group p-0 unordered_list justify-content-start">
                            {/* <li>
                              <Link className="btn btn-primary" to="/services">
                                <span className="btn_label" data-text="All Services">All Services</span>
                                <span className="btn_icon">
                                  <i className="fa-solid fa-arrow-up-right" />
                                </span>
                              </Link>
                            </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li 
                  className="dropdown"
                  onMouseEnter={() => handleDropdownMouseEnter('industries')}
                  onMouseLeave={() => handleDropdownMouseLeave('industries')}
                >
                  <a 
                    className="nav-link" 
                    href="#" 
                    id="industries_submenu" 
                    role="button"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown('industries');
                    }}
                    aria-expanded={dropdownStates.industries}
                  >
                    Industries We Serve
                  </a>
                  <div 
                    className={`dropdown-menu mega_menu_wrapper ${dropdownStates.industries ? 'show' : ''}`} 
                    aria-labelledby="industries_submenu">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="megamenu_pages_wrapper mb-5">
                            <div className="row">
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/Ai-data-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={aiIndustryIcon} alt="ai-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">AI &amp; Data</small>
                                  </span>
                                  <span className="description mb-0">
                                    Data Labeling, Prompt Writing, ML support
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/It-and-software-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={webDevIndustryIcon} alt="web-dev-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">IT &amp; Software Development</small>
                                  </span>
                                  <span className="description mb-0">
                                    Developer augmentation, QA support, project coordination
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/startups-and-entrepreneur-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={startupIndustryIcon} alt="startup-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Startups &amp; Entrepreneurs</small>
                                  </span>
                                  <span className="description mb-0">
                                    Admin support, pitch deck prep, calendar &amp; inbox management
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/education-and-coaching-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={educationIndustryIcon} alt="education-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Education &amp; Coaching</small>
                                  </span>
                                  <span className="description mb-0">
                                    LMS management, student support, content preparation
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/marketing-and-advertising-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={marketingIndustryIcon} alt="marketing-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Marketing &amp; Advertising</small>
                                  </span>
                                  <span className="description mb-0">
                                    Email campaigns, SEO, content scheduling, reporting
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/healthcare-and-wellness-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={healthcareIndustryIcon} alt="healthcare-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Healthcare &amp; Wellness</small>
                                  </span>
                                  <span className="description mb-0">
                                    Medical admin support, patient coordination, billing follow-up
                                  </span>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/real-estate-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={realEstateIndustryIcon} alt="real-estate-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">Real Estate</small>
                                  </span>
                                  <small className="description mb-0">
                                    Lead generation, CRM updates, appointment scheduling
                                  </small>
                                </Link>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <Link className="iconbox_block_2" to="/e-commerce-and-retail-industry" onClick={handleDropdownLinkClick}>
                                  <span className="icon_title_wrap">
                                    <small className="iconbox_icon">
                                      <img src={ecommerceIndustryIcon} alt="ecommerce-industry SVG Icon" />
                                    </small>
                                    <small className="iconbox_title">E-commerce &amp; Retail</small>
                                  </span>
                                  <small className="description mb-0">
                                    Product listing, order management, customer support
                                  </small>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <Link className="nav-link" to="/pricing">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/about">
                    About Us
                  </Link>
                </li>
                {/* <li>
                  <Link className="nav-link" to="/portfolio">
                    Portfolio
                  </Link>
                </li> */}
                <li>
                  <Link className="nav-link" to="/blog">
                    Blogs
                  </Link>
                </li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
          </nav>
        </div>
        <div className="col-xl-3 col-lg-3 col-5">
          <ul className="header_btns_group unordered_list justify-content-end">
            <li>
              <button 
                className="mobile_menu_btn" 
                type="button" 
                onClick={toggleMobileMenu}
                aria-expanded={isMobileMenuOpen}
                aria-label="Toggle navigation"
              >
                <i className="far fa-bars" />
              </button>
            </li>
            <li>
              <Link className="btn btn-outline-light" to="/contact">
                <span className="btn_label" data-text="Get Talent">Get Talent</span>
                <span className="btn_icon">
                  <i className="fa-solid fa-arrow-right" />
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>

  );
}

export default Header;
